//Place code for the component in the jquery wrapper. If not adding jquery or just using vanilla JS you do NOT need to use the wrapper. This is important because wordpress doesn't allow the use of the $ by default. The code is commented out when empty to prevent the JS linter from throwing errors, uncomment to use it.
jQuery(document).ready(function ($) {

	// Displays the list that corosponds to the first category in the header
	$('.about-us__section-header-category:first').addClass('selected');
    var dataHeader = $('.about-us__section-header-category:first').data('header');
  	$('.about-us__section-post-menu').removeClass('active');
  	$('.about-us__section-post-menu.' + dataHeader).addClass('active');

	// displays the post corosponding to the first link in the list
    var firstList = $(".about-us__section-post-menu.active .about-us__section-post-menu-link:first").data("list");
	$(".about-us__section-post-menu.active .about-us__section-post-menu-link:first").addClass('selected');
	$('.about-us__section-post-content').removeClass('active');
	$('.about-us__section-post-content[data-slug="' + firstList + '"]:first').addClass('active');

	// Get the data-link attribute value
	$('.about-us__section-post-menu-link').on('click', function() {
		// Removes the selected class from all the links then adds to selected link
		$('.about-us__section-post-menu-link').removeClass('selected');
		$(this).addClass('selected');
		// Gets the data-link attribute value of the selected link and adds it to the corosponding post preview
		var dataLink = $(this).data('list');
		$('.about-us__section-post-content').removeClass('active');
		$('.about-us__section-post-content[data-slug="' + dataLink + '"]:first').addClass('active');

	});

	//On click of a header lilnk it changes the list to the corosponding category
	$('.about-us__section-header-category').click(function () {
		// Removes the selected class from all the links then adds to selected link
		$('.about-us__section-header-category').removeClass('selected');
		$(this).addClass('selected');
		
		// Gets the data-link attribute value of the selected link and adds it to the corosponding post preview
		var dataHeader = $(this).data('header');
		$('.about-us__section-post-menu').removeClass('active');
		$('.about-us__section-post-menu.' + dataHeader).addClass('active');

		// Removes the selected class from all the links then adds to the first link in the new menu
		$('.about-us__section-post-menu-link').removeClass('selected');
		$(".about-us__section-post-menu.active .about-us__section-post-menu-link:first").addClass('selected');

		var firstList = $(".about-us__section-post-menu.active .about-us__section-post-menu-link:first").data("list");
		$('.about-us__section-post-content').removeClass('active');
		$('.about-us__section-post-content[data-slug="' + firstList + '"]:first').addClass('active');

	});

	var initialSelection = $('#about-select').val();
	$('.about-us__accordion-wrapper.' + initialSelection).removeClass('hidden');

	$('#about-select').change(function(){
		var selected =  $(this).val();

		$('.about-us__accordion-wrapper').removeClass('open').addClass('hidden');

		// $('.about-us__accordion-wrapper').hasClass(selcted).removeClass('hidden');
		$('.about-us__accordion-wrapper.' + selected).removeClass('hidden');

	})

	$('.about-us__accordion-wrapper').click(function(){

		if ($(this).hasClass('open')) {

			$(this).removeClass('open');

		} else {

			$('.about-us__accordion-wrapper').removeClass('open');
			$(this).addClass('open');

		}
	
	});

});
